<div class="editor-container">
    <div class="options">
      <!-- Text Format -->
      <button type="button" id="bold" class="option-button format">
        <i class="fa fa-bold"></i>
      </button>
      <button type="button" id="italic" class="option-button format">
        <i class="fa fa-italic"></i>
      </button>
      <button type="button" id="underline" class="option-button format">
        <i class="fa fa-underline"></i>
      </button>
      <button type="button" id="strikethrough" class="option-button format">
        <i class="fa fa-strikethrough"></i>
      </button>
      <button type="button" id="superscript" class="option-button script">
        <i class="fa fa-superscript"></i>
      </button>
      <button type="button" id="subscript" class="option-button script">
        <i class="fa fa-subscript"></i>
      </button>

      <!-- List -->
      <button type="button" id="insertOrderedList" class="option-button">
        <div class="fa fa-list-ol"></div>
      </button>
      <button type="button" id="insertUnorderedList" class="option-button">
        <i class="fa fa-list"></i>
      </button>

      <!-- Undo/Redo -->
      <button  type="button" id="undo" class="option-button">
        <i class="fa fa-rotate-left"></i>
      </button>
      <button  type="button" id="redo" class="option-button">
        <i class="fa fa-rotate-right"></i>
      </button>

      <!-- Link -->
      <button  type="button" id="createLink" #createLink class="adv-option-button">
        <i class="fa fa-link"></i>
      </button>
      <button type="button" id="unlink" class="option-button">
        <i class="fa fa-unlink"></i>
      </button>

      <!-- Alignment -->
      <button type="button" id="justifyLeft" class="option-button align">
        <i class="fa fa-align-left"></i>
      </button>
      <button type="button" id="justifyCenter" class="option-button align">
        <i class="fa fa-align-center"></i>
      </button>
      <button type="button" id="justifyRight" class="option-button align">
        <i class="fa fa-align-right"></i>
      </button>
      <button type="button" id="justifyFull" class="option-button align">
        <i class="fa fa-align-justify"></i>
      </button>
      <button type="button" id="indent" class="option-button spacing">
        <i class="fa fa-indent"></i>
      </button>
      <button type="button" id="outdent" class="option-button spacing">
        <i class="fa fa-outdent"></i>
      </button>
      <button  (click)="hindiTyping()" *ngIf="!editorService.class_hindi" class="btn" type="button"
        style="border: 1px solid black;width: 60px;background-color: rgb(183, 219, 255);">
        English
      </button>
      <button type="button" (click)="englishTyping()" *ngIf="editorService.class_hindi" class="btn"
        style="border: 1px solid black;width: 60px;background-color: rgb(183, 219, 255);">
        Hindi
      </button>
    </div>



    <div id="text-input" (keyup)="getAllcontent()">
      <div id="header" [class.hinditext]="editorService.class_hindi" #header>
        <!-- <label style=" float: right;">
            <span contenteditable="false"></span>
            <span contenteditable="false" style="font-weight: 700;" class="ml-5">Date: </span>
            <span contenteditable="false" style="padding-left:20px"> {{current_date}} </span>
          </label> -->
        <!--  simran comment code -->
        <!-- <label style=" float: right;">
            <span contenteditable="false"></span>
            <span  [class.hinditext]="class_hindi" contenteditable="false" style="font-weight: 700;" class="ml-5" *ngIf="class_hindi;else elseBlock">{{date_converter.krutidev}}
            </span>
            <ng-template #elseBlock>
              {{date_converter.english}}
            </ng-template>

            <span contenteditable="false" style="padding-left:20px"> {{current_date}} </span>
          </label>
          <div><br></div>
          <div><br></div>
          <div [class.hinditext]="class_hindi" class="row flex-column" contenteditable="false">
            <span></span>

          </div> -->
        <!--  simran comment code -->
        <!-- <div class="col-3" style="font-weight: bolder;">To , </div> -->
      </div>
      <div id="sub-body" class="font-size" #body (paste)="handlePaste($event)">
        <div [class.hinditext]="editorService.class_hindi">

          <!-- <div [class.hinditext]="class_hindi">
            <br [class.hinditext]="class_hindi" contenteditable="true"> -->
          <!-- <span style="font-size: 1rem;"><span style="font-weight: 700;">Description:</span>&nbsp; &nbsp;</span> -->
          <!-- <span style="font-size: 1rem;"></span> -->
          <!-- </div> -->

          <div [class.hinditext]="editorService.class_hindi" #contentInsideBody id="body-content" contenteditable="true">
            <span [class.hinditext]="editorService.class_hindi"><br></span>

            <!-- letter body is here  -->

          </div>


          <!-- <div [class.hinditext]="editorService.class_hindi">
            <span>&nbsp;
              <div><span><br></span></div>
              <div><span><br></span></div>
              <div><span><br></span></div>

              <div><br></div>
            </span>
          </div> -->
        </div>
      </div>

      <div [class.hinditext]="editorService.class_hindi" id="footer" style="font-size: 2.2rem;" #footer>
        <!-- <div style="position: relative; right:-79%;display: block;width: 22%;">


          </div> -->

      </div>

    </div>


  </div>
